import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import antdTheme from './theme/antdTheme';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import HowToCreate from './components/HowToCreate';
import Benefits from './components/Benefits';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import CreateAbhaPage from './pages/CreateAbhaPage';
import FetchAbhaPage from './pages/FetchAbhaPage';
import './App.css';

// About ABHA section (simple inline)
const AboutSection = () => (
  <section
    id="about"
    className="section-padding"
    style={{ background: '#fff' }}
  >
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Left */}
        <div>
          <div
            className="inline-block px-4 py-1 rounded-full text-xs font-bold tracking-widest mb-4"
            style={{ background: '#f0eaff', color: '#6B35D4', letterSpacing: '0.1em' }}
          >
            ABOUT ABHA
          </div>
          <h2 className="font-black mb-6" style={{ fontSize: 'clamp(1.6rem, 3vw, 2.2rem)', color: '#1a1a2e', lineHeight: 1.3 }}>
            Your Digital Health Identity for a Better India
          </h2>
          <p className="text-base leading-relaxed mb-5" style={{ color: '#555' }}>
            ABHA (Ayushman Bharat Health Account) is a 14-digit health ID issued by the National
            Health Authority under the Ayushman Bharat Digital Mission. It provides every Indian
            citizen with a unique digital health identity.
          </p>
          <p className="text-base leading-relaxed" style={{ color: '#555' }}>
            With your ABHA ID, you can store and share your medical records securely with
            hospitals, doctors, and health providers — giving you seamless healthcare access
            across India.
          </p>
        </div>

        {/* Right – stat cards */}
        <div className="grid grid-cols-2 gap-5">
          {[
            { value: '55 Cr+', label: 'ABHA IDs Created', color: '#6B35D4', bg: '#f5f0ff' },
            { value: '2+ Lakh', label: 'Health Facilities', color: '#E91E8C', bg: '#fff0f8' },
            { value: '14-digit', label: 'Unique Health ID', color: '#0ea5e9', bg: '#f0f9ff' },
            { value: '100%', label: 'Free & Secure', color: '#12B76A', bg: '#f0fdf4' },
          ].map((item) => (
            <div
              key={item.label}
              className="hover-lift rounded-2xl p-6 text-center"
              style={{ background: item.bg, border: `1px solid ${item.color}22` }}
            >
              <p className="font-black text-3xl mb-1" style={{ color: item.color }}>
                {item.value}
              </p>
              <p className="text-sm font-medium" style={{ color: '#555' }}>
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

const LandingPage = () => (
  <>
    <Navbar />
    <HeroSection />
    <AboutSection />
    <HowToCreate />
    <Benefits />
    <FAQ />
    <Footer />
  </>
);

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/create-abha" element={<CreateAbhaPage />} />
          <Route path="/fetch-abha" element={<FetchAbhaPage />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
